import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Minus, Plus } from "lucide-react";

const GRAY = "opacity-50 grayscale border-dashed text-muted-foreground";

export const SimQtyPicker = ({ qty, setQty, presets = [50, 100], max = Infinity, onUnavailable }) => {
  const [step, setStep] = useState(10);
  const pick = (n) => { if (n > max) { onUnavailable?.(n); return; } setStep(n); setQty(n); };
  const over = qty + step > max;
  const chip = (n) => <Button key={n} type="button" size="sm" variant="outline" aria-disabled={n > max}
    className={`rounded-full sim-chip h-7 px-3 text-xs ${n > max ? GRAY : step === n ? "border-primary text-foreground font-semibold" : "text-muted-foreground"}`}
    onClick={() => pick(n)} data-testid={`sim-qty-preset-${n}`}>Blocco da {n}</Button>;
  return <div className="flex flex-wrap items-center gap-2" data-testid="sim-qty-picker">
    <div className="inline-flex items-center rounded-full border border-border">
      <Button type="button" size="icon" variant="ghost" className="rounded-full h-9 w-9" disabled={qty - step < Math.min(10, max)} onClick={() => setQty(qty - step)} aria-label={`Togli ${step}`} data-testid="sim-qty-minus"><Minus className="w-4 h-4" /></Button>
      <span className="w-14 text-center font-semibold tabular-nums" data-testid="sim-qty-value">{qty}</span>
      <Button type="button" size="icon" variant="ghost" aria-disabled={over} className={`rounded-full h-9 w-9 ${over ? GRAY : ""}`} onClick={() => (over ? onUnavailable?.(qty + step) : setQty(qty + step))} aria-label={`Aggiungi ${step}`} data-testid="sim-qty-plus"><Plus className="w-4 h-4" /></Button>
    </div>
    {[10, ...presets].map(chip)}
    <span className="text-xs text-muted-foreground" data-testid="sim-qty-step">+ e − aggiungono o tolgono {step} SIM · per quantità in grigio chiedi al tuo riferimento</span>
  </div>;
};
